<template>
<div class="m-4 p-4">
	<p v-for="(p) in paragraph($t('intro-paragraph'))" v-html="p" :key="p"></p>
	<p v-for="(p) in paragraph($t('about-text'))" v-html="p" :key="p"></p>
	<h2>{{ $t('view-recent-meetings') }}</h2>

	<h3>{{ $t('filters') }}</h3>
	<div class="row mt-4 mb-4">
		<div class="col-12 col-md-4">
			<DatePicker element_class="" :label="$t('meetings-after')" :placeholder="$t('select-date')" :date="start_date" v-on:update="(event) => update_date(event, 'start_date')"></DatePicker>
		</div>
		<div class="col-12 col-md-4">
			<DatePicker element_class="" :label="$t('meetings-before')" :placeholder="$t('select-date')" :date="end_date" v-on:update="(event) => update_date(event, 'end_date')"></DatePicker>
		</div>
		<div class="col-12 col-md-4">
		<label for="filter-committee">{{ $t('filter-committee-more') }}</label>
		<select id="filter-committee" class="form-control" v-model="committee_name">
			<option value="">{{ $t('all') }}</option>
			<option v-for="(committee,index) in committees" :key="index">{{ committee.committee_name }}</option>
		</select>
		</div>
	</div>
	<div class="row mt-4 mb-4">
		<div class="col-12 col-md-4">
		<label for="search-meetings">{{ $t('search-meetings-more') }}</label>
		<input id="search-meetings" type="text" class="form-control" :placeholder="$t('search-example')" v-model="search_meetings" ref="search_meetings">
		</div>
	</div>
	<div v-if="filters.length || search_meetings">
		<h3>{{ $t('current-filters') }}</h3>
		<ul class="list-unstyled">
			<a v-if="committee_name" class="m-2 cursor badge badge-secondary" @click="committee_name = ''">{{ $t('committee') }} {{ committee_name }} </a>
			<a v-if="start_date" class="m-2 cursor badge badge-secondary" @click="start_date = ''">{{ $t('meetings-after') }} {{ start_date | moment($t('date-format'))}}</a>
			<a v-if="end_date" class="m-2 cursor badge badge-secondary" @click="end_date = ''">{{ $t('meetings-before') }} {{ end_date | moment($t('date-format'))}}</a>
			<a v-if="search_meetings" class="m-2 cursor badge badge-secondary" @click="search_meetings = ''">{{ $t('containing') }} {{ search_meetings }}</a>
		</ul>
	</div>
	<ul class="nav nav-tabs" role="tablist">
		<li class="nav-item">
			<a @click="set_meetings_tab" class="nav-link cursor" :class="{'active': results_tab==='meetings'}" role="tab">
				{{ $t('meeting-tab') }}
			</a>
		</li>
		<li class="nav-item">
			<a @click="set_agenda_tab" class="nav-link cursor" :class="{'active': results_tab==='agendas'}" role="tab">
				{{ $t('agenda-tab') }}
			</a>
		</li>
	</ul>

	<div v-if="error_message" class="alert alert-danger mt-4" role="alert" v-html="error_message"></div>

	<div class="tab-content">
		<div v-if="results_tab==='meetings'" class="tab-pane fade show active" role="tabpanel">
			<table class="table table-striped table-hover">
				<thead>
					<tr>
						<SortableColumn :direction="order_direction" :column_name="'meeting_date'" :column="order_column" v-on:order="order"></SortableColumn>
						<SortableColumn :direction="order_direction" :column_name="'committee_name'" :column="order_column" v-on:order="order"></SortableColumn>
					</tr>
				</thead>
				<tbody>
					<tr @click="open_meeting(meeting, $event)" class="cursor" v-for="(meeting,index) in meetings" :key="index">
						<td><router-link :to="{ name: 'meeting', params: { meeting_id: meeting.meeting_id }}">{{ meeting.meeting_date | moment($t('date-format')) }}</router-link></td>
						<td>{{ meeting.committee_name }}</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div class="tab-pane fade show active"  role="tabpanel" v-if="results_tab==='agendas'">
			<div v-if="search_type !== 'search'" class="callout callout-warning">
				<h4>{{ $t('no-search-terms') }}</h4>
			</div>
			<ParsedMotions v-if="search_type === 'search'" :motions="search_motions" :suppress_context="false" v-on:order="order" :loading="loading"></ParsedMotions>
		</div>
	</div>
	<button v-if="limit > 0" type="button" class="mt-4 btn btn-primary" @click="view_more">{{ $t('view-more') }}</button>
</div>
</template>

<script>

//import axios from 'axios'
import OpenData from '@/libraries/OpenData';
import DatePicker from '@/components/DatePicker';
import ParsedMotions from '@/components/ParsedMotions';
import SortableColumn from '@/components/SortableColumn';
import moment from 'moment';

const LIMIT = 10;

export default {
	components: { DatePicker, ParsedMotions, SortableColumn },
	data() {
		return {
			results_tab: 'meetings',
			filter_meetings: [],
			limit: LIMIT,
			offset: 0,
			loading: false,
			committees: [],
			committee_name: '',
			search_meetings: '',
			start_date: '',
			end_date: '',
			search_motions: [],
			order_column: 'meeting_date',
			order_direction: 'DESC',
			error_message: '',
		}
	},

	watch: {
		search_meetings(to) {
			if (to.length > 3) {
				this.set_agenda_tab();
				this.reset();
				this.fetch_data();
			} else {
				if (this.filter_meetings.length === 0) {
					this.set_meetings_tab();
					this.reset();
					this.fetch_data();
				}
			}
		},

		filters() {
			this.reset();
			this.fetch_data();
		},
		order_parameters() {
			this.reset();
			this.fetch_data();
		}
	},

	created() {
		this.get_committees();
		this.fetch_data();
	},

	computed: {


		meetings() {
			if (this.search_type === 'search') {
				let meetings_data = {};
				let order = [];
				let results = [];
				this.search_motions.forEach(row => {
					if (!meetings_data.hasOwnProperty(row.meeting_id)) {
						meetings_data[row.meeting_id] = row;
						order.push(row.meeting_id);
					}
				})
				order.forEach(meeting_id => {
					results.push(meetings_data[meeting_id]);
				})
				return results;
			}
			return this.filter_meetings;
		},

		order_parameters() {
			return [{key: this.order_column, direction: this.order_direction }];
		},

		search_parameters() {
			let where_parameters = JSON.parse(JSON.stringify(this.filters));
			where_parameters.push([{column: 'title', type: 'LIKE', params: [this.search_meetings]}]);
			let limit_parameters = {limit: this.limit, offset: this.offset };
			let group_parameters = {
				select: ['motion_id'],
				group: ['motion_id'],
			}
			return { where_parameters, limit_parameters, group_parameters }
		},

		parameters() {
			let where_parameters = JSON.parse(JSON.stringify(this.filters));
			let order_parameters = this.order_parameters;
			let limit_parameters = {limit: this.limit, offset: this.offset };
			let group_parameters = {
				function_column: 'meeting_id',
				function: 'count',
				select: ['meeting_id','meeting_date','committee_name'],
				group: ['meeting_id','meeting_date','committee_name']
			};
			return { where_parameters, order_parameters, limit_parameters, group_parameters}

		},

		search_type() {
			if (this.search_meetings.length > 3) {
				return 'search';
			}
			return 'filter';
		},

		filters() {
			let where_parameters = [];
			if (this.committee_name) {
				where_parameters.push([{column: 'committee_name', type: '=', params: [this.committee_name]}]);
			}
			if (this.start_date) {
				where_parameters.push([{column: 'meeting_date', type: '>=', params: [this.start_date]}]);
			}
			if (this.end_date) {
				where_parameters.push([{column: 'meeting_date', type: '<=', params: [this.end_date]}]);
			} else {
				//for cache breaking purposes
				let format_date = moment(Date.now()).format('YYYY-MM-DDTHH:mm:ss.SSS');
				where_parameters.push([{column: 'meeting_date', type: '<=', params: [format_date]}]);
			}
			return where_parameters;
		}
	},

	methods: {

		open_meeting(meeting,event) {
			if (!event.target || !event.target.nodeName || (event.target.nodeName !== "A")) {
				//this convoluted conditional ensures no NavigationDuplicated error
				//because clicking on a link will also trigger the row based @click event
				//(if the user clicks on the link instead of anything else, it will cancel the @click method router navigation)
				this.$router.push({name: 'meeting', params: { meeting_id: meeting.meeting_id}});
			}
		},

		paragraph(text) {
			return text.split("\r\n");
		},

		set_meetings_tab() {
			this.results_tab = 'meetings';
		},

		set_agenda_tab() {
			this.results_tab = 'agendas';
			this.$refs.search_meetings.focus();
		},

		grouped_search_parameters(meeting_ids) {
			let order_parameters = this.order_parameters;
			let where_parameters = [[{column: 'motion_id', type: '=', params: meeting_ids}]];
			return { where_parameters, order_parameters }
		},

		update_date(new_date,date_name) {
			this[date_name] = new_date;
		},

		async get_committees() {
			try {

			let where_parameters = [];
			let order_parameters = [{key: 'committee_name', direction: 'ASC' }];
			let group_parameters = {
				select: ['committee_name'],
				group: ['committee_name'],
			}
			this.committees = await OpenData.getResults(this.$API_URL,{ where_parameters, order_parameters, group_parameters });
			} catch(error) {
				this.handle_errors(error);
			}
		},

		view_more() {
			this.fetch_data();
		},

		async fetch_searches() {
			try {
				const group_params = this.search_parameters;
				const meeting_ids = await OpenData.getResults(this.$API_URL,group_params);
				if (meeting_ids.length) {
					const params = this.grouped_search_parameters(meeting_ids.map(row => row.motion_id));
					if (meeting_ids.length < LIMIT) {
						this.limit = 0;
					}
					const data = await OpenData.getResults(this.$API_URL, params);
					return data;
				}
			} catch(error) {
				this.handle_errors(error);
			}
			return [];
		},

		async fetch_meetings() {
			const params = this.parameters;
			try {

				const data = await OpenData.getResults(this.$API_URL,params);
				if (data.length < LIMIT) {
					this.limit = 0;
				}
				return data;
			} catch(error) {
				this.handle_errors(error);
				return [];
			}
		},

		async fetch_data() {
			if (!this.loading) {
				this.loading = true;
				const search = (this.search_type === 'search');
				const data = (search) ? await this.fetch_searches() : await this.fetch_meetings();
				this.loading = false;
				if (!data.length) {
					this.offset = 0;
					this.limit = 0;
				} else {
					this.offset += this.limit;
					if (search) {
						this.search_motions = this.search_motions.concat(data);
					} else {
						this.filter_meetings = this.filter_meetings.concat(data);
					}
				}
			}
		},

		reset() {
			this.filter_meetings = [];
			this.search_motions = [];
			this.offset = 0;
			this.limit = LIMIT;
		},

		order(column,direction) {
			this.order_column = column;
			this.order_direction = direction;
		},

		handle_errors(error) {
			if (error.code && error.code===403) {
				this.error_message = this.$t('authenticate_error');
			} else {
				this.error_message = error.message;
			}
		}

	},

}
</script>

<style>
.cursor {
	cursor: pointer;
}
</style>

